export default __webpack_public_path__ + "70f2ff166435b3e35b95e8688d461a08.wasm";